import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { prepareHeaders } from '@/lib/cookie'
import { BASE_URL } from '@/constant'

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders,
  paramsSerializer: params => {
    const searchParams = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        value.forEach(item => searchParams.append(key, String(item)))
      } else if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, String(value))
      }
    }
    return searchParams.toString()
  },
})

export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)

  if (result.error && result.error.status === 401) {
    const refreshToken = Cookies.get('refreshToken')

    if (refreshToken) {
      try {
        const refreshResponse = await axios.post(
          `${BASE_URL}/auth/refresh-token`,
          { refreshToken }
        )

        if (refreshResponse.data.accessToken) {
          Cookies.set('token', refreshResponse.data.accessToken)
          if (refreshResponse.data.refreshToken) {
            Cookies.set('refreshToken', refreshResponse.data.refreshToken, {
              expires: 7,
            })
          }

          result = await baseQuery(args, api, extraOptions)
        } else {
          handleLogout()
        }
      } catch {
        handleLogout()
      }
    } else {
      handleLogout()
    }
  }

  return result
}

function handleLogout() {
  Cookies.remove('token')
  Cookies.remove('refreshToken')
  if (window.location.pathname !== '/login') {
    window.location.href = '/login'
  }
}
